[
    {
        "category": "💛 Gratitude",
        "folder": "a",
        "count": 8
    }
]
